import React from 'react';
import CommonRequestPage from './components/CommonRequestPage';

const ApprovedRequest = () => {
  return (
    <CommonRequestPage
      pageType={'approved'}
      pageTitle={'Approved Price Change Request'}
      key={'approved'}
    />
  );
};

export default ApprovedRequest;
